import ActiveTag from "@components/common/ActiveTag";
import SeeMoreButton from "@components/common/SeeMoreButton";
import FormModal from "@modules/requestAQuote/FormModal";
import { MAX_RAQ_FORM_WIDTH } from "@modules/requestAQuote/components/RaQForm";
import TripPreferencesDetail from "@modules/requestAQuote/components/TripPreferencesDetail";
import { createRef, useEffect, useState } from "react";

export interface ITag {
  id: number;
  title?: string;
  type?: string;
  notRemovable?: boolean;
  Title?: string;
  propertyCategory?: string;
  categoryName?: string;
  name?: string;
}

interface IProps {
  accommodationTags: ITag[];
  autoPlacesTags: ITag[];
  importantTags: ITag[];
  locations: ITag[];
  handleRemoveTag: (tagData: string, tagType: string) => void;
}

const TripPreferences = ({
                           accommodationTags,
                           autoPlacesTags,
                           importantTags,
                           locations,
                           handleRemoveTag,
                         }: IProps): JSX.Element => {
  const ref = createRef<HTMLInputElement>();
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    if (ref.current) {
      if (ref.current.clientHeight < ref.current.scrollHeight) {
        setShowMore(true);
      } else {
        setShowMore(false);
      }
    }
  }, [ref, accommodationTags, autoPlacesTags, importantTags]);

  const [isPrefModalVisible, setIsPrefModalVisible] = useState(false);
  const closeModalHandler = (): void => {
    setIsPrefModalVisible(false);
  };

  const allTags = [
    ...locations.map((tag) => (
      <ActiveTag
        key={
          tag.title ? `${tag.id}${tag.title}` : `${tag.id}${tag?.Title ?? ""}`
        }
        tagData={tag}
        isFormB={true}
      />
    )),
    ...importantTags.map((tag) => (
      <ActiveTag
        key={
          tag.title ? `${tag.id}${tag.title}` : `${tag.id}${tag?.Title ?? ""}`
        }
        tagData={tag}
        onClick={tag.notRemovable ? undefined : (handleRemoveTag as () => void)}
        isFormB={true}
      />
    )),
    ...accommodationTags.map((tag) => {
      return (
        <ActiveTag
          key={
            tag.title ? `${tag.id}${tag.title}` : `${tag.id}${tag?.Title ?? ""}`
          }
          tagData={tag}
          onClick={
            tag.notRemovable ? undefined : (handleRemoveTag as () => void)
          }
          isFormB={true}
        />
      );
    }),
    ...autoPlacesTags.map((tag) => (
      <ActiveTag
        key={
          tag.title ? `${tag.id}${tag.title}` : `${tag.id}${tag?.Title ?? ""}`
        }
        tagData={tag}
        onClick={tag.notRemovable ? undefined : (handleRemoveTag as () => void)}
        isFormB={true}
      />
    )),
  ];

  return (
    <>
      {allTags.length > 0 && (
        <div className="flex flex-col gap-3 px-[1.5rem] py-[1rem] bg-white rounded-3xl">
          <span className="text-p">
            Your Trip Wishlist
          </span>
          <div
            ref={ref}
            className={`flex max-h-[60px] flex-wrap gap-1 overflow-y-hidden`}
          >
            {allTags}
          </div>
          {showMore && (
            <SeeMoreButton
              onClickHandler={(event) => {
                event.preventDefault();
                setIsPrefModalVisible(true);
              }}
            />
          )}
        </div>
      )}
      {isPrefModalVisible && (
        <FormModal
          title="Trip Preferences"
          closeModalHandler={closeModalHandler}
          maxDesktopWidth={MAX_RAQ_FORM_WIDTH}
        >
          <TripPreferencesDetail
            accommodationTags={accommodationTags}
            autoPlacesTags={autoPlacesTags}
            importantTags={importantTags}
            locations={locations}
            handleRemoveTag={handleRemoveTag}
          />
        </FormModal>
      )}
    </>
  );
};

export default TripPreferences;
